// i18n-Setup für die Onboarding-Web-App.
// Sprachen: Deutsch (Quelle), Englisch, Arabisch (RTL), Französisch.
// Erkennung: ?lng=… (z. B. aus Einladungslink) → localStorage → Browser → htmlTag.
// Weitere Sprachen = nur ein zusätzliches Locale-JSON + Eintrag in SUPPORTED_LANGS.

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import de from './locales/de.json';
import en from './locales/en.json';
import ar from './locales/ar.json';
import fr from './locales/fr.json';

export const SUPPORTED_LANGS = ['de', 'en', 'ar', 'fr'] as const;
export type Lang = (typeof SUPPORTED_LANGS)[number];

/** Eigenbezeichnung der Sprache (für den Umschalter). */
export const LANG_LABELS: Record<Lang, string> = {
  de: 'Deutsch',
  en: 'English',
  ar: 'العربية',
  fr: 'Français',
};

/** Rechts-nach-links-Sprachen. */
export const RTL_LANGS = new Set<Lang>(['ar']);

export function baseLang(lng: string | undefined): Lang {
  const b = (lng ?? 'de').split('-')[0] ?? 'de';
  return (SUPPORTED_LANGS as readonly string[]).includes(b) ? (b as Lang) : 'de';
}

/** Setzt dir=rtl|ltr und lang=… auf <html> passend zur aktiven Sprache. */
export function applyDirection(lng: string | undefined): void {
  const base = baseLang(lng);
  const dir = RTL_LANGS.has(base) ? 'rtl' : 'ltr';
  const html = document.documentElement;
  html.setAttribute('dir', dir);
  html.setAttribute('lang', base);
}

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      en: { translation: en },
      ar: { translation: ar },
      fr: { translation: fr },
    },
    fallbackLng: 'de',
    supportedLngs: [...SUPPORTED_LANGS],
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lng',
      lookupLocalStorage: 'gql_lang',
      caches: ['localStorage'],
    },
  });

// Initiale Richtung + bei jedem Sprachwechsel aktualisieren.
applyDirection(i18n.language);
i18n.on('languageChanged', applyDirection);

export default i18n;
